import React from "react";
import Icon from "@ant-design/icons";

const EmojiSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12.844 11.75a3.224 3.224 0 01-1.156 1.201c-.48.288-1.024.44-1.579.44a3.065 3.065 0 01-1.578-.44 3.224 3.224 0 01-1.156-1.201"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      d="M12.625 3.509a7 7 0 103.866 3.866"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.67"
      d="M7.648 8.523h.006m.268 0a.273.273 0 11-.547 0 .273.273 0 01.547 0zM12.314 8.523h.038m.273 0a.273.273 0 11-.547 0 .273.273 0 01.547 0z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      d="M13.5 5.188h3.063M15.031 6.719V3.656"
    />
  </svg>
);

const EmojiIcon = (props) => {
  return <Icon component={EmojiSvg} {...props} />;
};

const EmojiV3Svg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      d="M6 12C9.29014 12 12.0058 9.28433 12.0058 6C12.0058 2.71567 9.28433 0 5.9942 0C2.70986 0 0 2.71567 0 6C0 9.28433 2.71567 12 6 12ZM4.24758 5.43133C3.88781 5.43133 3.59188 5.11219 3.59188 4.67118C3.59188 4.21857 3.88781 3.90522 4.24758 3.90522C4.60155 3.90522 4.90329 4.21857 4.90329 4.67118C4.90329 5.11219 4.60155 5.43133 4.24758 5.43133ZM7.77563 5.43133C7.41586 5.43133 7.12573 5.11219 7.12573 4.67118C7.12573 4.21857 7.41586 3.90522 7.77563 3.90522C8.12959 3.90522 8.43714 4.21857 8.43714 4.67118C8.43714 5.11219 8.12959 5.43133 7.77563 5.43133ZM3.87041 7.706C3.87041 7.56093 4.01547 7.4913 4.15474 7.55513C4.59574 7.78723 5.11219 8.05416 5.9942 8.05416C6.88201 8.05416 7.39845 7.78143 7.83946 7.55513C7.97292 7.4913 8.12379 7.56093 8.12379 7.706C8.12379 8.11219 7.27079 8.95938 5.9942 8.95938C4.7234 8.95938 3.87041 8.11219 3.87041 7.706Z"
      fill="#165ABF"
    />
  </svg>
);

const EmojiIconV3 = (props) => {
  return <Icon component={EmojiV3Svg} {...props} />;
};

const EmojiWhiteSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M9.99609 17C13.8346 17 17.0029 13.8317 17.0029 10C17.0029 6.16828 13.8278 3 9.98932 3C6.1576 3 2.99609 6.16828 2.99609 10C2.99609 13.8317 6.16437 17 9.99609 17ZM7.95161 9.33656C7.53188 9.33656 7.18662 8.96422 7.18662 8.44971C7.18662 7.92166 7.53188 7.55609 7.95161 7.55609C8.36457 7.55609 8.7166 7.92166 8.7166 8.44971C8.7166 8.96422 8.36457 9.33656 7.95161 9.33656ZM12.0677 9.33656C11.6479 9.33656 11.3094 8.96422 11.3094 8.44971C11.3094 7.92166 11.6479 7.55609 12.0677 7.55609C12.4806 7.55609 12.8394 7.92166 12.8394 8.44971C12.8394 8.96422 12.4806 9.33656 12.0677 9.33656ZM7.51157 11.9903C7.51157 11.8211 7.68081 11.7398 7.84329 11.8143C8.3578 12.0851 8.96031 12.3965 9.98932 12.3965C11.0251 12.3965 11.6276 12.0783 12.1421 11.8143C12.2978 11.7398 12.4739 11.8211 12.4739 11.9903C12.4739 12.4642 11.4787 13.4526 9.98932 13.4526C8.50673 13.4526 7.51157 12.4642 7.51157 11.9903Z"
      fill="#F9FBFE"
    />
  </svg>
);

const EmojiWhiteIcon = (props) => {
  return <Icon component={EmojiWhiteSvg} {...props} />;
};

export { EmojiIcon, EmojiIconV3, EmojiWhiteIcon };